// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.2697 2.33587L10.5546 1.76416L6.85015 10.0999V21.9999H17.4838C18.9645 21.9999 20.2238 20.9196 20.4489 19.4561L21.6336 11.7561C21.9131 9.93884 20.5071 8.29995 18.6684 8.29995H14.7997V5.84599C14.7997 4.2534 13.7806 2.83949 12.2697 2.33587Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.99976 10.0999V21.9999H4.84976L4.84943 10.0999H1.99976Z"}}]};

const ThumbUp2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-2-filled',
    ref,
    icon: element,
  },
));

ThumbUp2FilledIcon.displayName = 'ThumbUp2FilledIcon';

export default ThumbUp2FilledIcon;
